import React from 'react'
import PageHeadSection from '../admin/components/PageHeadSection'
import AdminDynamicCreateOrUpdatePage from '../admin/AdminDynamicCreateOrUpdatePage'
import { useDispatch } from 'react-redux'
import { IAxiosDefaultDataObject } from '../../config'
import { Dispatch, UnknownAction } from '@reduxjs/toolkit'
import { addNewWarehouse } from './warehousesSlice'
import { IWarehouseModel } from './WarehousesApp'

export default function NewWarehousesPage() {

    const dispatch = useDispatch()

    const updateItem = (item: IAxiosDefaultDataObject, dispatch: Dispatch<UnknownAction>) => dispatch(addNewWarehouse((item as IWarehouseModel)))

    return <AdminDynamicCreateOrUpdatePage updateItem={updateItem} />
}